// extracted by mini-css-extract-plugin
module.exports = {"PersonaTitle":"PersonaTitle_PersonaTitle__3-f3u","image":"PersonaTitle_image__1Uv-d","header":"PersonaTitle_header__2739k"};